// Module
var code = `<!-- clFigure — image with caption.
     Data shape: { src, alt, caption?, width? }
     Width defaults to 100% via CSS when the attribute isn't set. -->
<figure class="block-cl-figure">
  <img
    class="block-cl-figure__image"
    src="{{src}}"
    alt="{{alt}}"
    {{#width}}style="width: {{width}}"{{/width}}
  />
  {{#caption}}<figcaption class="block-cl-figure__caption">{{caption}}</figcaption>{{/caption}}
</figure>
`;
// Exports
module.exports = code;